import { duration } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { trackSize, trackSizeHover } from "../config";
import { trackStyles } from "./trackStyles";
import isPropValid from "@emotion/is-prop-valid";
export const TrackY = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  top: 0;
  height: 100%;
  transition: width ${duration.animation.fast}ms ease;
  width: ${trackSize};

  ${trackStyles};

  &.hover,
  &.active,
  &:hover,
  &:active {
    width: ${trackSizeHover};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhY2tZLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2Nyb2xsYmFyL3N0eWxlZC9UcmFja1kudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQzFFLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxTQUFTLEVBQUUsY0FBYyxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBQ3RELE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFDNUMsT0FBTyxXQUFXLE1BQU0sd0JBQXdCLENBQUM7QUFFakQsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsVUFBVSxDQUFDO0lBQzFDLGlCQUFpQixFQUFFLFdBQVc7Q0FDL0IsQ0FBQyxDQUFBOzs7c0JBR29CLFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSTtXQUNsQyxTQUFTOztJQUVoQixXQUFXOzs7Ozs7YUFNRixjQUFjOztDQUUxQixDQUFDIn0=